import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';

export const ProductTitle = styled(Text)`
  text-transform: uppercase;
  color: ${tokens.color.text_light};
  ${tokens.text('caption')};
`;
